export default ({ request }) => ({
  masterColorListApi(data = {}) {
    return request({
      url: '/master/master/color/list',
      method: 'post',
      data,
    })
  },
  masterColorDetailApi(data = {}) {
    return request({
      url: '/master/master/color/detail',
      method: 'post',
      data,
    })
  },
  masterColorSaveApi(data = {}) {
    return request({
      url: '/master/master/color/save',
      method: 'post',
      data,
    })
  },
  masterColorDelApi(data = {}) {
    return request({
      url: '/master/master/color/del',
      method: 'post',
      data,
    })
  },
  masterColorSubmitApi(data = {}) {
    return request({
      url: '/master/master/color/submit',
      method: 'post',
      data,
    })
  },
  masterColorReviewApi(data = {}) {
    return request({
      url: '/master/master/color/review',
      method: 'post',
      data,
    })
  },
  masterColorRejectApi(data = {}) {
    return request({
      url: '/master/master/color/reject',
      method: 'post',
      data,
    })
  },
  bizDict(data = {}) {
    return request({
      url: '/master/master/color/main/color',
      method: 'post',
      data,
    })
  },
})
